import { Dialog, DialogContent, DialogTitle } from "@/lib/components/Dialog";

export default function PreviewVideoDialog({
  open,
  onOpenChange,
  title,
  video,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title: string;
  video: string;
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        className="max-w-3xl overflow-hidden border-0 bg-black [&>[data-slot=dialog-close]]:z-10 [&>[data-slot=dialog-close]]:bg-black/50 [&>[data-slot=dialog-close]]:text-white [&>[data-slot=dialog-close]]:hover:bg-black/70 [&>[data-slot=dialog-close]]:hover:text-white"
        classNameInner="p-0 sm:p-0"
      >
        <DialogTitle className="sr-only">{title}</DialogTitle>
        <video
          src={video}
          controls
          autoPlay
          muted
          playsInline
          className="w-full bg-black"
        />
      </DialogContent>
    </Dialog>
  );
}
